<template>
  <div>
    <div class="text-muted small">
      {{activity.created_at | formatRelativeDate}}
    </div>
    <!--USER LINK-->
    <UserLink :user="activity.causer"/>

    <!--ACTIVITY LOG ACTION-->
    {{ $t('actions.' + $options.filters.slugify(activity.description)) }}
    <!--CREATED-->
    <div v-if="activity.description === 'added'">

      <div v-if="activity.subject">
        <span> {{ $t('generic_controls.framework_controls.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.framework_control.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('generic_controls.log.title') }}</span>
        <router-link :to="{ name: 'generic_controls.view', params: { slug: activity.subject.generic_control.slug }}">
          {{activity.subject.generic_control.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('generic_controls.framework_controls.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.framework_control.name}}</span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('generic_controls.log.title') }}</span>
        <router-link :to="{ name: 'generic_controls.view', params: { slug: activity.properties.generic_control.slug }}">
          {{activity.properties.generic_control.name}}
        </router-link>
      </div>
    </div>

    <!--DELETED-->
    <div v-if="activity.description === 'removed'">
      <div v-if="activity.subject">
        <span> {{ $t('generic_controls.framework_controls.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.framework_control.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('generic_controls.log.title') }}</span>
        <router-link :to="{ name: 'generic_controls.view', params: { slug: activity.subject.generic_control.slug }}">
          {{activity.subject.generic_control.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('generic_controls.framework_controls.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.framework_control.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('generic_controls.log.title') }}</span>
        <router-link :to="{ name: 'generic_controls.view', params: { slug: activity.properties.generic_control.slug }}">
          {{activity.properties.generic_control.name}}
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';

  export default {
    name: 'GenericControlFramework',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    props: {
      activity: {},
      changes: false
    },
    components: {
      UserLink
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }

        }

        return words.join(' ');
      },
      removedData : function(properties){

        let results = [];

        for(var i=0; i < properties.old.data_objects.length; i++){

          let removed = true;

          for(var j=0; j < properties.attributes.data_objects.length; j++) {

            if(properties.old.data_objects[i].id === properties.attributes.data_objects[j].id){
              removed = false;
            }
          }

          if(removed){
            results.push(properties.old.data_objects[i]);
          }

        }

        return results
      },
      addedData : function(properties){
        let results = [];

        for(var i=0; i < properties.attributes.data_objects.length; i++){

          let added = true;

          for(var j=0; j < properties.old.data_objects.length; j++) {

            if(properties.attributes.data_objects[i].id === properties.old.data_objects[j].id){
              added = false;
            }
          }

          if(added){
            results.push(properties.attributes.data_objects[i]);
          }

        }

        return results
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
